export { default } from './InstallmentDetails'
